export default "__VITE_ASSET__nQSu3gkx__"